export const getLearningObjectWithContents = /* GraphQL */ `
  query GetLearningObject($id: ID!) {
    getLearningObject(id: $id) {
      id
      title
      description
      areaId
      areaNames
      course
      code
      type
      published
      contents {
        items {
          id
          learningObjectId
          contentId
          content {
            id
            title
            url
            posterUrl
          }
          title
          description
          cameraOrbit
          cameraTarget
          fieldOfView
          hotspots {
            items {
              id
              title
              normal
              cameraOrbit
              cameraTarget
              fieldOfView
              learningObjectContentId
            }
            nextToken
          }
        }
        nextToken
      }
      sortedContentIds
    }
  }
`;
